import { Link } from "gatsby"
import Header from "../../components/Header"
import Layout from "../../components/Layout"
import { btn, btnPrimary } from "../../ds/button.module.css"
import { WhiteArrowRight } from "../../ds/Shapes"

const comparisons = [
  {
    slug: "ingo-vs-premagic",
    competitor: "InGo",
    tagline:
      "InGo automates social sharing. Premagic gives you the full event marketing lifecycle — with creative freedom InGo can't match.",
    categories: ["Social Advocacy", "Event Marketing"],
  },
]

export default function ComparePage() {
  return (
    <Layout
      title="Compare Premagic | See How Premagic Stacks Up"
      description="Honest, side-by-side comparisons of Premagic vs other event marketing and advocacy platforms. See features, pricing, and real differences."
      keywords={[
        "premagic comparison",
        "premagic vs ingo",
        "event marketing comparison",
        "social advocacy tools",
        "event advocacy platform",
      ]}
    >
      <div style={{ backgroundColor: "#7251F4" }}>
        <Header isWhiteLogo />
      </div>

      <section
        className="py-16 md:py-24"
        style={{ backgroundColor: "#7251F4" }}
      >
        <div className="px-5 md:px-0 mx-auto md:w-[1080px] text-center">
          <p className="text-white/60 uppercase tracking-widest text-xs font-semibold mb-4">
            Compare
          </p>
          <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
            How does Premagic compare?
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto">
            Honest, side-by-side breakdowns so you can make the right choice for
            your events.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 px-5 md:px-0">
        <div className="mx-auto md:w-[1080px]">
          <div className="grid md:grid-cols-2 gap-6">
            {comparisons.map(item => (
              <Link
                key={item.slug}
                to={`/compare/${item.slug}/`}
                className="group block rounded-2xl border border-gray-200 p-8 hover:shadow-lg hover:border-[#7251F4]/30 transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-sm font-bold text-[#7251F4] bg-[#7251F4]/10 px-3 py-1 rounded-full">
                    vs
                  </span>
                  <h2 className="text-xl font-bold text-black group-hover:text-[#7251F4] transition-colors">
                    {item.competitor} vs Premagic
                  </h2>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  {item.tagline}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex gap-2">
                    {item.categories.map(cat => (
                      <span
                        key={cat}
                        className="text-xs text-gray-400 border border-gray-200 rounded-full px-3 py-1"
                      >
                        {cat}
                      </span>
                    ))}
                  </div>
                  <span className="text-[#7251F4] text-sm font-medium group-hover:translate-x-1 transition-transform duration-300 inline-block">
                    Read comparison &rarr;
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 px-5 md:px-0 bg-[#F7F5FF]">
        <div className="mx-auto md:w-[1080px] text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">
            Don&rsquo;t see your platform?
          </h2>
          <p className="text-gray-600 mb-8 max-w-xl mx-auto">
            We&rsquo;re adding new comparisons regularly. Request a custom
            comparison or talk to our team about how Premagic fits your stack.
          </p>
          <Link
            to="/request-a-demo/"
            className={`${btn} ${btnPrimary} text-xs relative w-max group mx-auto`}
          >
            <span className="mr-4 ml-2">Request a Demo</span>
            <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
          </Link>
        </div>
      </section>
    </Layout>
  )
}
